import { j as a } from "../../../../jsx-runtime-B6kdoens.js";
import { a as m } from "../../../../index-CROKJrb5.js";
import { c as f, f as s } from "../../../../create-component-CBAeEoQ6.js";
import { CardMeta as p } from "../../CardMeta/index.js";
const d = f(
  "BeforeAfterCardMeta",
  s(
    ({ children: r, className: t, ...e }, o) => /* @__PURE__ */ a.jsx(p, { ref: o, className: m("-cur-mt-2", t), ...e, children: r })
  )
);
export {
  d as BeforeAfterCardMeta
};
//# sourceMappingURL=index.js.map
